var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoIconDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#0069CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3633 67V61.45C38.3633 59.6333 38.6383 58.0917 39.1883 56.825C39.7383 55.5583 40.5549 54.4917 41.6383 53.625C42.7383 52.7417 44.1133 51.9833 45.7633 51.35L52.4133 48.8C53.8633 48.2167 54.9299 47.5 55.6133 46.65C56.3133 45.8 56.6633 44.75 56.6633 43.5C56.6633 42.25 56.2049 41.2 55.2883 40.35C54.3883 39.4833 53.0966 39.05 51.4133 39.05C49.7966 39.05 48.4383 39.4583 47.3383 40.275C46.2549 41.075 45.6299 42.25 45.4633 43.8H38.9133C38.9633 41.5833 39.5383 39.7417 40.6383 38.275C41.7383 36.8083 43.2133 35.7167 45.0633 35C46.9133 34.2667 48.9966 33.9 51.3133 33.9C53.4966 33.9 55.4716 34.3167 57.2383 35.15C59.0049 35.9667 60.4049 37.1167 61.4383 38.6C62.4883 40.0667 63.0133 41.7833 63.0133 43.75C63.0133 45.4167 62.7049 46.8833 62.0883 48.15C61.4883 49.4167 60.5716 50.525 59.3383 51.475C58.1049 52.425 56.5466 53.2667 54.6633 54L47.9633 56.6C46.6633 57.1 45.7216 57.6583 45.1383 58.275C44.5549 58.875 44.2633 59.6667 44.2633 60.65V61.6H62.8133V67H38.3633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoIconDesktop);
export default __webpack_public_path__ + "static/media/two_icon_desktop.d4705246dbd5cf4e97a533ccc3dd4269.svg";
export { ForwardRef as ReactComponent };